module.exports = __webpack_public_path__ + "static/img/footer.eb6ea9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer.png
// module id = or/K
// module chunks = 10